import React from "react";

// Full-bleed editorial marquee between major sections. Pulls text from props
// so it can be reused — single scroll track duplicated so the loop is seamless.
export default function Marquee({ items = [], testid = "section-marquee" }) {
  const line = items.length ? items : ["BOB9INE", "LOVER BOY II", "OUT NOW", "RVA"];
  return (
    <div
      data-testid={testid}
      className="relative overflow-hidden border-t border-b border-white/5 py-10"
    >
      <div className="marquee-track flex whitespace-nowrap gap-12 text-[#F5F5F0]">
        {Array.from({ length: 2 }).flatMap((_, i) =>
          line.map((it, j) => (
            <span
              key={`${i}-${j}`}
              className="font-display uppercase text-5xl md:text-7xl tracking-tighter inline-flex items-center gap-10"
            >
              {it}
              <span className="w-2 h-2 rotate-45 bg-[#B31B1B]" aria-hidden="true" />
            </span>
          ))
        )}
      </div>
    </div>
  );
}
